export default __webpack_public_path__ + "static/media/caera-4.e8c4fe7d.webm";